import Vue from 'vue'
import Vuex from 'vuex'

import axios from "axios";
import moment from "moment";
import _ from "underscore";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    packages:[],
    searchString:"",
    jobList:[],
      countries:[],
      cities:[],
      adds:[],
      topbarAdd:[],
      homeAfterSliderAdd:[],
      homeBeforeFooterAdd:[],
      sMWCoursesAdd:[],
      employerDashboardLeftSide:[],
      employerDashboardRightSide:[],
      employerDashboardCenter:[],
      categories:[],
      jobTypes:[],
      experiences:[],
      languages:[],
      filteredCities:[
          { key: 716, value: "Lahore"},
          { key: 743, value: "Islamabad"},
          { key: 687, value: "Rawalpindi"},
          { key: 729, value: "Karachi"},
          { key: 751, value: "Faisalabad"},
          { key: 749, value: "Gujranwala"},
          { key: 696, value: "Peshawar"},
          { key: 709, value: "Multan"}
      ],
      degreeLevels:[],
      disabilityTypes:[],
      isClearCookies:false,
      totalPages: []  ,
      totalJobs: 0

  },
  mutations: {
    clearCookies(state,isClearCookies){
        state.isClearCookies=isClearCookies;

    },
    /*setSearchString(state, searchString){
      state.searchString = searchString
    },*/
    setPackages(state,packages){
        state.packages=packages;
    },
    setJobs(state, list){
      state.jobList = list.slice().reverse();
    },
      setCountries(state, countries){
          state.countries = countries;
      },
      setCities(state, cities){
          state.cities = cities;
      },
      setAdds(state, adds){
        state.adds = adds;
      },
      setCategories(state, categories){
          state.categories = categories;
      },
      setJobTypes(state, jobTypes){
          state.jobTypes = jobTypes;
      },
      setExperiences(state, experiences){
          state.experiences = experiences;
      },
      setLanguages(state, languages){
          state.languages = languages;
      },
      setDisabilityTypes(state,DisabilityTypes){
        state.disabilityTypes=DisabilityTypes
      },
      /*setFilteredCities(state, filteredCities){
          state.filteredCities = filteredCities;
      },*/
      setDegreeLevels(state, degreeLevels){
          state.degreeLevels = degreeLevels;
      },
      setTotalPages(state, totalPages) { // New mutation to set total pages
        state.totalPages = totalPages;
    },

        setTotalJobs(state, totalJobs) {
            state.totalJobs = totalJobs;
        }
    },
  actions: {

    clearCookies(context,domainName) {
        if ('caches' in window) {
          try {
            // Split all cookies into an array
            const allCookies = document.cookie.split(';');
      
            // Iterate through each cookie and delete it
            for (let i = 0; i < allCookies.length; i++) {
              // Trim leading spaces
              const cookie = allCookies[i].trim();
              
              // Extract the cookie name (before the '=' symbol)
              const eqPos = cookie.indexOf('=');
              const cookieName = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      
              // Clear the cookie by setting the expiry date to the past
              document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domainName}`;
      
              //console.log(`Cleared cookie: ${cookieName}`);
            }
            context.commit("clearCookies",true);
      
            // Log the updated cookies after clearing
            //console.log('Cookies after clearing:', document.cookie);
          } catch (error) {
            console.error('Error clearing cookies:', error);
          }
        } else {
          console.warn('Cache API is not supported in this browser.');
        }
      },
      
    
    getAll(context){
      //this.rerender();
      let list = [];


      axios.get('/api/Job/GetAlljobsOfEmployeer')
          .then(res =>{
            if (res.status != '200') {
              //console.log('error.....')
              const error = new Error('Failed to fetch!');
              return error;
            }


            /*forEach((item, index) => {
          const country = {
            id: item.gnId,
            title: item.name,
          };*/

            let allJobList = res.data.data;
            let currentDate = moment(String(new Date())).format('YYYY-MM-DD')
            for(let job in allJobList){
              if(allJobList[job].status == "Approved" && moment(String(allJobList[job].jobExpiryDate)).format('YYYY-MM-DD') >= currentDate){
                list.push(allJobList[job]);
              }
            }
            //console.log("get all list : ", list);
            context.commit("setJobs", list)

          }).catch(error => {
        //console.log(error);
        this.errored = true;
      })
          .finally(() => {
            if (this.errored) {

              //console.log("Error : Sorry there is no response");
              // this.$bvToast.toast("Sorry there is no response ", {
              //   toaster: "b-toaster-top-center",
              //   variant: "danger",

              //   solid: true,
              // });
            }
          });
    },
    getPackages(context) {
        let packages=[];
        axios
          .get("/api/EmployerJobPostPackage/GetAllJobPostPackagesByEmployeeId")
          .then((res) => {
            if (res.status != "200") {
              //console.log("error.....");
              const error = new Error("Failed to fetch!");
              return error;
            }else{
                //console.log("ResPackages",res.data.data)
                packages = res.data.data;
                context.commit("setPackages", packages);
                //console.log("PACKAGES : ", packages);
            }
          })
          .catch((error) => {
            //console.log(error);
          })
          .finally(() => { });
      },


    getJobsByNameAndCityId(context, searchFilter){
        //console.log("search Filter : ", searchFilter)
      //this.rerender();
      let list = [];
      if(searchFilter != {}){
        let model = {
          jobTitle : searchFilter.jobTitle,
          cityId : searchFilter.cityId
        }
        axios
            .post("/api/Job/GetJobsSearch", model)
            .then(res => {
              // code that we will 'try' to run

              let jobList = res.data.data;
              let currentDate = moment(String(new Date())).format('YYYY-MM-DD')
              for(let job in jobList){
                if(jobList[job].status == "Approved" && moment(String(jobList[job].jobExpiryDate)).format('YYYY-MM-DD') >= currentDate){
                  list.push(jobList[job]);
                }
              }
              //console.log("Add Response portion");
              //console.log("response : ", list);
              context.commit("setJobs", list)
              if(list.length == 0){
                this.$bvToast.toast("No Record Found ", {
                  toaster: "b-toaster-top-center",
                  variant: "warning",

                  solid: true
                 
                });
                alert("there is no job against this filter");
              }
            })
            .catch(error => {
              //console.log("Errorrrrrr : ",error);
              this.errored = true;
            })
            .finally(() => {
              if (this.errored) {

                //console.log("Error : Sorry there is no response");
              } else {
              }
            });
      }
      else {
      }
    },

      //Get Dropdowns List
      getCountryList(context){
          let countries = [];
          let rawCountries = [];
          let model = {
              type: "Country"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run
                  rawCountries = res.data.data;

                  //console.log("Add Response portion");
                  countries = _.sortBy(rawCountries, 'value');
                  context.commit("setCountries", countries)
                  //console.log("cities : ", countries);
              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {

                      //console.log("Error : Sorry there is no response");
                      // this.$bvToast.toast("Sorry there is no response ", {
                      //   toaster: "b-toaster-top-center",
                      //   variant: "danger",

                      //   solid: true,
                      // });
                  } else {


                  }
              });
      },
      getCityList(context){
          let cities = [];
          let rawCities = [];
          let model = {
              type: "City"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run
                  rawCities = res.data.data;

                  //console.log("Add Response portion");
                  cities = _.sortBy(rawCities, 'value');
                  context.commit("setCities", cities)
                  //console.log("cities : ", cities);
              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {

                      //console.log("Error : Sorry there is no response");
                      // this.$bvToast.toast("Sorry there is no response ", {
                      //   toaster: "b-toaster-top-center",
                      //   variant: "danger",

                      //   solid: true,
                      // });
                  } else {
                  }
              });
      },

      getCategories(context) {



          let categories = [];
          var rawCategories = [];
          let model = {
              type: "Category"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run
                  rawCategories = res.data.data;

                  //console.log("Add Response portion");
                  // categories = _.sortBy(rawCategories, 'value');
                  context.commit("setCategories", rawCategories)
                  //console.log("this.categories in getall : ", rawCategories);
              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {
                      //console.log("Error : Sorry there is no response");
                     
                  } else {
                  }
              });
      },
      getDisailityTypes(context) {
        var rawDisabilityType = [];
        let model = {
            type: "DisabilityType"
        };

        axios
            .post("/api/KeyValuePair/GetDropDownListByIds", model)
            .then(res => {
                // code that we will 'try' to run
                rawDisabilityType = res.data.data;

                //console.log("Add Response portion");
                // categories = _.sortBy(rawCategories, 'value');
                context.commit("setDisabilityTypes", rawDisabilityType)
                //console.log("this is DisabilityType : ", rawDisabilityType);
            })
            .catch(error => {
                //console.log("Errorrrrrr while getting DisabilityType : ",error);
                this.errored = true;
            })
            .finally(() => {
                if (this.errored) {

                    //console.log("Error : Sorry there is no response while getting the DisabilityTypes");
                    
                } else {
                }
            });
    },
      getJobTypes(context) {


          let jobTypes = [];
          let model = {
              type: "JobType"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run
                  jobTypes = res.data.data;

                  //console.log("Add Response portion");

                  context.commit("setJobTypes", jobTypes)
                  //console.log("this.jobTypes in getall : ", jobTypes);
              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {

                      //console.log("Error : Sorry there is no response");
                      
                  } else {
                  }
              });

      },
      getExperiences(context) {
          let filteredExperiences = [];
          var rawExperience = [];
          let model = {
              type: "ExperienceLevel"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run
                  rawExperience = res.data.data;

                  //console.log("Add Response portion");

                  //filteredExperiences = _.sortBy(rawExperience, 'value');
                  context.commit("setExperiences", rawExperience)
                  //console.log("this.filteredExperiences in getall : ", rawExperience);

              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {
                      //console.log("Error : Sorry there is no response");
                  } else {
 }
              });
          },
      getLanguageList(context){
          let languages = [];
          let rawLanguages = [];
          let langs = [];
          let model = {
              type: "Languages"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run

                  rawLanguages = _.sortBy(res.data.data, 'value');

                  for (let lang in rawLanguages) {

                      languages.push(rawLanguages[lang].value);

                  }
                  //console.log("Add Response portion");


                  context.commit("setLanguages", languages)
                  //console.log("languages : ", languages);
              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {

                      //console.log("Error : Sorry there is no response");
                      // this.$bvToast.toast("Sorry there is no response ", {
                      //   toaster: "b-toaster-top-center",
                      //   variant: "danger",

                      //   solid: true,
                      // });
                  } else {






                  }
              });
      },
     
      getDegreeLevel(context) {

          let degreeLevels = [];
          let model = {
              type: "DegreeLevel"
          };

          axios
              .post("/api/KeyValuePair/GetDropDownListByIds", model)
              .then(res => {
                  // code that we will 'try' to run
                  degreeLevels = res.data.data;

                  //console.log("Add Response portion");

                  context.commit("setDegreeLevels", degreeLevels)
                  //console.log("this.degreeLevels in getall : ", degreeLevels);
              })
              .catch(error => {
                  //console.log("Errorrrrrr : ",error);
                  this.errored = true;
              })
              .finally(() => {
                  if (this.errored) {

                      //console.log("Error : Sorry there is no response");
                      // this.$bvToast.toast("Sorry there is no response ", {
                      //   toaster: "b-toaster-top-center",
                      //   variant: "danger",

                      //   solid: true,
                      // });
                  } else {

                  }
              });
      },
       getJobsByFilters(context, filter) {
        let list = [];
        let TotalpageIndexs = [];
        //console.log("filter : ", filter);
  
        if (filter != {}) {
          let model = {
            jobTypes: filter.JobTypes,
            degreelevels: filter.DegreeLevels,
            jobSubTypes: filter.JobSubTypes,
            disabilityTypes: filter.disabilityTypes,
            cities: filter.Cities,
            empExperiences: filter.EmpExperiences,
            isOthersSelected: filter.isOthersSelected,
            PageSize: filter.PageSize,
            PageNumber: filter.PageNumber,
            TotalPages: filter.TotalPages,
            Text: filter.Text,
            TotalRecord: filter.TotalRecord,
            JobTitle : filter.JobTitle
          };
          //console.log("model : ", model);
          axios
            .post("/api/Job/JobFilter", model)
            .then(res => {
              let jobList = res.data.data.jobs;
              let TotalJobs = res.data.data.totalJobCount;
              let totalPageCount = res.data.data.totalPages;
  
              if (totalPageCount > 0) {
                TotalpageIndexs = Array.from({ length: totalPageCount }, (_, i) => i + 1);
              }
  
            
                //console.log("Add Response portion");
                //console.log("response : ", jobList);
                context.commit("setJobs", jobList);

                context.commit("setTotalJobs", TotalJobs);
                context.commit("setTotalPages", TotalpageIndexs);
                //console.log("Total Pages : ", TotalpageIndexs);
                if (list.length == 0) {
                    this.$bvToast.toast("No Record Found ", {
                        toaster: "b-toaster-top-center",
                  variant: "warning",
                  solid: true
                });
              }
            })
            .catch(error => {
              //console.log("Errorrrrrr : ", error);
              this.errored = true;
            })
            .finally(() => {
              if (this.errored) {
                //console.log("Error : Sorry there is no response");
              }
            });
        }
      },


      getJobsByCompanyId(context, companyId){

          let list = [];


          //console.log("company Id In store : ", companyId)
          axios.get('/api/Job/GetAlljobsOfEmployeer')
              .then(res =>{
                  if (res.status != '200') {
                      //console.log('error.....')
                      const error = new Error('Failed to fetch!');
                      return error;
                  }


                  let jobRecord = res.data.data;

                  //console.log("jobRecord in company : ", jobRecord)


                  let currentDate = moment(String(new Date())).format('YYYY-MM-DD')
                  //console.log("currentDate Format : ",currentDate)
                  for (let data in jobRecord){

                      //console.log("expired date: ", moment(String(jobRecord[data].jobExpiryDate)).format('YYYY-MM-DD') ,": current date : ", currentDate)
                      if((jobRecord[data].companyId == companyId && jobRecord[data].status == "Approved") && moment(String(jobRecord[data].jobExpiryDate)).format('YYYY-MM-DD') >= currentDate){
                          /*this.list[data] = jobRecord [data];*/
                          list.push(jobRecord [data]);
                      }

                  }
                  //console.log("this.list in company : ",list);

                  context.commit("setJobs", list)


              }).catch(error => {
              //console.log(error);
              this.errored = true;
          })
              .finally(() => {
                  if (this.errored) {

                      //console.log("Error : Sorry there is no response");
                      // this.$bvToast.toast("Sorry there is no response ", {
                      //   toaster: "b-toaster-top-center",
                      //   variant: "danger",

                      //   solid: true,
                      // });
                  }
              });

      },

      fetchAdds(context){
          let adds = [];

              let addsModel = {
                  "pageSize": 0,
                  "pageNumber": 1,
                  "totalRecord": 0,
                  "text": ""
              }

              axios
                  .post("/api/Adds/GetAdd", addsModel)
                  .then(res => {
                      // code that we will 'try' to run

                      let jobList = res.data.data;
                      adds = jobList
                      //console.log("Add Response portion");

                      //console.log("response : ", adds);
                      context.commit("setAdds", adds)
                  })
                  .catch(error => {
                      //console.log("Errorrrrrr : ",error);
                      this.errored = true;
                  })
                  .finally(() => {
                      if (this.errored) {

                          //console.log("Error : Sorry there is no response");
                          // this.$bvToast.toast("Sorry there is no response ", {
                          //   toaster: "b-toaster-top-center",
                          //   variant: "danger",

                          //   solid: true,
                          // });
                      } else {

                          /*this.$bvToast.toast("Updated Successfully ", {
                            toaster: "b-toaster-top-center",
                            variant: "success",

                            solid: true
                          });*/


                      }
                  });


      }


  },
  getters:{
      getTotalJobs(state) {
          return state.totalJobs; // Case-sensitivity issue: should be state.totalJobs
      },
      getTotalPages(state) { // New getter for total pages
          return state.totalPages;
      },
    getClearCache(){
        return state.isCacheClear;
    },
    getPackages(state,getters){
        if(state.packages!=[]){
            return state.packages;
        }

    },

    showAllJobs(state, getters){
      if(state.jobList != []){
        return state.jobList;
      }

    },
      availableCities(state, getters){
        return state.cities;
      },
      availableDisabilityTypes(state,getters){
        return state.disabilityTypes;
      },
      availableCategories(state, getters){
          //console.log("this.categories in getall : ", state.categories);
          return state.categories
      },
      availableJobTypes(state, getters){
          //console.log("this.jobTypes in getall : ", state.jobTypes);
          return state.jobTypes
      },
      availableExperiences(state, getters){
       
          //console.log("this.filteredExperiences in getall : ", state.experiences);
          // return filteredExperiences.filter(exp => exp.id > 0)
          return state.experiences;
      },
      availableFilteredCities(state, getters){
          //console.log("this.filteredCities in getall : ", state.filteredCities);
          return state.filteredCities
      },
      availableDegreeLevels(state, getters){
          //console.log("this.filteredCities in getall : ", state.degreeLevels);
          return state.degreeLevels
      },
      //    available adds
      availableTopBarAdds(state, getters){
          let topbarAdd = []


              for (const item of state.adds) {
                  if(item.title == "JobPortal TopBar"){
                      topbarAdd.push({
                          id : item.addsId,
                          title : item.title,
                          image : item.addImage,
                          url: item.bannerUrl
                      });
                  }
              }
          return topbarAdd.filter(item => item.id > 0)
      },
      availableHomeAfterSliderAdd(state, getters){
          let homeAfterSliderAdd = []
          for (const item of state.adds) {
              if(item.title == "HomePage After Slider"){
                  homeAfterSliderAdd.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return homeAfterSliderAdd.filter(item => item.id > 0)
      },
      availableHomeUpSkillVlearnAdd(state, getters){
          let homeUpSkillVlearnAdd = []
          for (const item of state.adds) {
              if(item.title == "JobPortal/UPSkill with Vii Learn"){
                  homeUpSkillVlearnAdd.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return homeUpSkillVlearnAdd.filter(item => item.id > 0)
      },
      availableHomeBeforeFooterAdd(state, getters){
          let homeBeforeFooterAdd = []
          for (const item of state.adds) {
              if(item.title == "Home Page Before Footer"){
                  homeBeforeFooterAdd.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return homeBeforeFooterAdd.filter(item => item.id > 0)
      },
      availableSMWCoursesAdd(state, getters){
          let sMWCoursesAdd = []
          for (const item of state.adds) {
              if(item.title == "SMW Courses Add"){
                  sMWCoursesAdd.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return sMWCoursesAdd.filter(item => item.id > 0)
      },
      availableEmployeeDashboardCenterAdd(state, getters){
          let sMWCoursesAdd = []


          for (const item of state.adds) {
              if(item.title == "JobPortal/EmployeeDashboardCenter"){
                  sMWCoursesAdd.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return sMWCoursesAdd.filter(item => item.id > 0)
      },
      availableEmployerDashboardLeftSide(state, getters){
          let employerDashboardLeftSide = []
          for (const item of state.adds) {
              if(item.title == "Employer Dashboard Left Side"){
                  employerDashboardLeftSide.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return employerDashboardLeftSide.filter(item => item.id > 0)
      },
      availableEmployerDashboardRightSide(state, getters){
          let employerDashboardRightSide = []


          for (const item of state.adds) {
              if(item.title == "Employer Dashboard Right"){
                  employerDashboardRightSide.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return employerDashboardRightSide.filter(item => item.id > 0)
      },
      availableEmployerDashboardCenter(state, getters){
          let employerDashboardCenter = []


          for (const item of state.adds) {
              if(item.title == "Employer Dashboard Center"){
                  employerDashboardCenter.push({
                      id : item.addsId,
                      title : item.title,
                      image : item.addImage,
                      url: item.bannerUrl
                  });
              }
          }
          return employerDashboardCenter.filter(item => item.id > 0)
      },

  },
  modules: {
  }
})
